<div class="d-flex justify-content-between align-items-center">
  <h1 class="stock-title">Stock Unit Search</h1>
  <button
    style="color: #037493; border: 1px solid #c1c5cb; margin-right: 35px"
    (click)="openStockSheetModal()"
  >
    <ds-icon icon="download" class="icon-align"></ds-icon>
    <div class="align_btn">Download Stock Sheet</div>
  </button>
</div>

<br />

<app-results-count></app-results-count>

<br /><br />
<!-- Spacer -->
<div class="mt-3"></div>

<app-filters

  (filtersChanged)="onFiltersChanged($event)"
></app-filters>

<br />
<div class="mt-3"></div>
<br />
<div class="content_bg styled-section">
  <table class="scrollable-table">
    <ds-tabs>
      <ds-tabs-label
        for="a"
        (click)="onPlannedDealerTabClick(); $event.preventDefault()">Planned Dealer
      </ds-tabs-label>
      <ds-tabs-content id="a">
        <div class="tab-content">
          <app-table
            [rowsData]="rowsData"
            [columnData]="plannedDealerColumnData"
            [showTable]="showTable"
            [showResults]="showResults"
          ></app-table>
        </div>
      </ds-tabs-content>

      <ds-tabs-label for="b" (click)="onDealerStockClick()">Dealer Stock</ds-tabs-label>
      <ds-tabs-content id="b">
        <div class="tab-content">
          <app-table
            [rowsData]="rowsData"
            [columnData]="dealerColumnData"
            [showTable]="showTable"
            [showResults]="showResults"
          >
          </app-table>
        </div>
      </ds-tabs-content>

      <ds-tabs-label for="d" (click)="onSMSStockClick()">SMS Stock</ds-tabs-label>
      <ds-tabs-content id="d">
        <div class="tab-content">
          <div *ngIf="showResults; else notYetSearched">
          <div *ngIf="showTable; else noStock">
            <div class="table-section">
              <div class="table-scroll-container">
                <table *ngIf="showTable" class="ds-table zebra-table fixed-header-table">

                  <thead >
                  <tr class="table_head">
                    <th *ngFor="let col of smsColumnData">{{ col.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of stockRowsData">
                      <td *ngFor="let column of smsColumnData">
                        <ng-container [ngSwitch]="column.field">
                          <!-- Image field -->
                          <ng-container *ngSwitchCase="'image'">
                            <div class="image-popup-wrapper">
                              <img
                                [src]="row.image"
                                alt="Car Image"
                                class="car-thumbnail"
                              />
                              <div class="image-hover-popup">
                                <img [src]="row.image" alt="Vehicle Enlarged View" />
                              </div>
                            </div>
                          </ng-container>
                          <!-- VIN field -->
                          <ng-container *ngSwitchCase="'VIN'">
                            <a
                              [href]="row.VIN | unitOverviewLink"
                              target="_blank"
                              rel="noopener"
                              style="font-weight: bold; color: #037493; text-decoration: none; cursor: pointer;"
                              title="View Unit Overview"
                              tabindex="0"
                            >
                              {{ row.VIN }}
                            </a>
                          </ng-container>
                          <!-- stat field -->
                          <ng-container *ngSwitchCase="'stat'">
                            <a
                              [ngStyle]="{'color': Number(row.stat) === 11 ? '#009966' : Number(row.stat) >= 50 ? '#CC3333' : '#FF6A00'}"
                              style="font-weight: bold; color: #037493; text-decoration: none; cursor: pointer;"
                              title="Unit Update"
                              href="/unit-update?vin={{ row.VIN }}&bodyNo={{ row.bodyNo }}"
                              target="_blank"
                              rel="noopener"
                              tabindex="0"
                            >
                              {{ row.stat }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'model'">
                            {{ row.modelCode }} - {{ row.description }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'template'">
                            {{ row.template }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'pw'">
                            {{ row.pw }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'rfi'">
                            {{ row.rfi }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'ltp'">
                            {{ row.ltp }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'exterior'">
                            {{ row.exterior }}
                          </ng-container>
                          <ng-container *ngSwitchCase="'interior'">
                            {{ row.interior }}
                          </ng-container>

                          <!-- action field -->
                          <ng-container *ngSwitchCase="'action'">
                            <a
                              style="font-weight: bold; color: #037493; text-decoration: none; cursor: pointer;"
                              title="View Pricing"
                              class="action transfer"
                              (click)="onPricingClick(row.VIN.toString())"
                              (keydown)="console.log(row.VIN)"
                              tabindex="0"
                            >View Pricing</a>
                          </ng-container>
                          <!-- options field -->
                          <ng-container *ngSwitchCase="'options'">
                            <span
                              style="cursor: pointer; text-decoration: underline"
                              [ds-popover-trigger-for]="popover"
                              *ngIf="row.options"
                              tabindex="0"
                            >
                              {{ row.optionsCount }}
                            </span>
                            <ds-popover #popover>
                              <ds-box-header>Options</ds-box-header>
                              <ds-box-content>
                                <ng-container *ngFor="let opt of row.options">
                                  <div>{{ opt.optionCode }}: {{ opt.optionDescription }}</div>
                                </ng-container>
                              </ds-box-content>
                              <ds-box-footer *ngIf="!row.options.length">
                                No options
                              </ds-box-footer>
                            </ds-popover>
                          </ng-container>
                          <!-- Default cell for other fields -->
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                  </table>
              </div>
            </div>
          </div>
          </div>
        </div>
      </ds-tabs-content>
    </ds-tabs>
  </table>
</div>



<br />
<ds-modal
  #stockSheetModal
  [ds-modal-trigger-for]="stockSheetModal"
  [(isModalOpen)]="stockSheetModalIsOpen"
  [dimensionsConfig]="{ width: '585px', height: 'auto' }"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Download Stock Sheet
  </ds-box-header>
  <ds-box-content>
    <div>
      <span>
        You are about to download a stocksheet, please allow some time for the
        sheet to process.
      </span>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <ds-button (click)="downloadStockSheet()"> Download Stock Sheet </ds-button>
  </ds-box-footer>
</ds-modal>
<!--<app-unit-update-modal></app-unit-update-modal>-->
<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 65vh;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Use the filters and click 'Search' to find what you need.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 65vh;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO STOCK AVAILABLE</h1>
      <p style="margin: 0">
        Try adjusting your filters or search criteria to find available results.
      </p>
    </div>
  </div>
</ng-template>
<app-model-pricing-modal></app-model-pricing-modal>
